const $ = require('jquery');

const navbarToggler = $('.navbar-toggler');
const body = $('body');

function scrollToTop() {
  $('.to-top').click(function () {
    $('html,body').animate({ scrollTop: 0 }, 1000);
    return false;
  });
}

function showScrollToTop() {
  $(document).scroll(function () {
    const scrollPos = $(this).scrollTop();
    const pageHeight = $(document).height() / 2;

    if (scrollPos > pageHeight) {
      $('.to-top').addClass('to-top--visible');
    } else {
      $('.to-top').removeClass('to-top--visible');
    }
  });
}

function openMobilemenu() {
  navbarToggler.click(function () {
    let getStatus = navbarToggler.attr('aria-expanded');

    if (getStatus == 'false') {
      body.addClass('overflow-hidden');

      $(window).resize(function() {
        if ($(window).width() < 992) {
          body.addClass('overflow-hidden');
        }
        else {
          body.removeClass('overflow-hidden');
        }
      });

    } else {
      body.removeClass('overflow-hidden');
    }
  });


}

function openSubmenu() {
  $('.header .icon-arrow').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      $(this).parent().next().addClass('show');
      $(this).parent().next().find('ul >:first-child').addClass('is-active')
    });

    return false;
  });

  $('.back').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      if ($(this).closest('.back-forwards').next().find('.is-active').prev('.dropdown').length == 1) {
        $(this).closest('.back-forwards').next().find('.is-active').prev().addClass('is-active');
        $(this).closest('.back-forwards').next().find('.is-active').next().removeClass('is-active');
        $('.forwards ').show();
      } else {
        $(this).closest('.dropdown-menu').removeClass('show');
      }
    });
  });

  $('.forwards').each(function () {
    $(this).click(function (e) {
      e.preventDefault();

      if ($(this).closest('.back-forwards').next().find('.is-active').next('.dropdown').length == 1) {
        $(this).closest('.back-forwards').next().find('.is-active').next().addClass('is-active');
        $(this).closest('.back-forwards').next().find('.is-active').prev().removeClass('is-active');

        if ($(this).closest('.back-forwards').next().find('.is-active').next('.dropdown').length != 1) {
          $('.forwards ').hide();
        }
      } else {
          $('.forwards ').hide();
      }
    });
  });
}

function scrollTo() {
  $('[data-class="block-hero_startpage"]').click(function () {
    let get_class = $(this).attr('data-class');
    let get_header_height = $('.header').height();
    $('html,body').animate({ scrollTop: $('.' + get_class).next().offset().top - get_header_height + 40 }, 'slow');
  });
}

function init() {
  if (typeof Object.assign != 'function') {
    Object.assign = function (target) {
      'use strict';
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      target = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var source = arguments[index];
        if (source != null) {
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
      }
      return target;
    };
  }

  scrollToTop();
  // showScrollToTop();
  scrollTo();
  // openSubmenu();
  openMobilemenu();

  // $('.the-tree__point-content').each(function () {
  //   $(this).hover(function () {
  //     if (!$(this).hasClass('is-open')) {
  //       $(this).addClass('is-open')
  //       $('[data-tippy-root]').each(function () {
  //         $(this).fadeOut();
  //       });
  //       $(this).trigger('click');
  //     } else {
  //       $('[data-tippy-root]').each(function () {
  //         $(this).fadeOut();
  //       });
  //     }
  //
  //     $('.tippy-content h3').each(function () {
  //       $(this).on("click", function(){
  //         $(this).next().slideDown();
  //       });
  //     });
  //   });
  // });
  //
  // $('.click-event').on("click", function(){
  //   alert('...');
  //   // $('.the-tree__point-content').each(function () {
  //   //   $(this).removeClass('is-open')
  //   //     $('.tippy-content h3').each(function () {
  //   //       $(this).next().slideUp();
  //   //     });
  //   //   });
  //   });

  $('.video-overlay .play-button').each(function () {
    $(this).click(function () {
      //console.log($(this).closest('.video-overlay').next())
      $(this).closest('.video-overlay').next().modal('show');
      $(this).closest('.video-overlay').next().find('video').trigger('play');
    });
  });

  $('.modal').on('hidden.bs.modal', function () {
    $(this).find('video').trigger('pause');
  });

  $('.readmore__content').each(function () {
    $(this).click(function () {
      let getText = $(this).html();

      if (getText == '[ <span>»</span> weiterlesen … ]') {
        $(this).html('[ <span>»</span> weniger]')
      } else {
        $(this).html('[ <span>»</span> weiterlesen … ]')
      }

      if ($(this).prev().hasClass('show-more-container')) {
        $(this).prev().slideToggle();
      } else if ($(this).parent('p')) {
        $(this).closest('.readmore').next().slideToggle();
      } else {
        $(this).prev().find('.show-more-container').slideToggle();
      }
    });
  });

  let currentTab = 1;
  $('[data-toggle="collapse"]').each(function (index) {
    $(this).click(function () {
      if (index == currentTab) {
        return
      }

      $('.tree-animation > *').fadeOut();
      $('.tree-animation > *:nth-child('+ index +')').fadeIn();
      currentTab = index;
    });
  });
}

export default {
  init,
};
